import { ALARM_DEFINITION_SERVICE_NAME, AlarmDefinitionServiceProvider } from './alarm-definition.service'

export const ALARM_DEFINITION_SERVICES_MODULE_NAME = 'simax.services.alarm-definition'

const alarmDefinitionServicesModule = angular.module(ALARM_DEFINITION_SERVICES_MODULE_NAME, [])

alarmDefinitionServicesModule.provider(ALARM_DEFINITION_SERVICE_NAME, AlarmDefinitionServiceProvider)
